import cxs from 'cxs';
import { COLOURS } from '../../../../../common/styles/vars';

export const LIST_ITEM = ({ onClick }) => cxs({
  ...(onClick ? { cursor: 'pointer' } : {}),
  alignItems: 'center',
  background: COLOURS.mono.white,
  borderRadius: '6px',
  display: 'flex',
  height: '130px',
  justifyContent: 'space-between',
  paddingLeft: '25px',
  paddingRight: '25px'
});